<div class="popup-header-row">
  <div class="popup-header-title">
    <app-popup-text-container
      [paragraphHeadingText]="paragraphHeadingText"
      [status]="status"
    />
  </div>

  <app-popup-pdf-download-trigger
    class="popup-header-trigger"
    [isLoading]="isLoading"
    [tooltip]="downloadTooltipLabel"
    (trigger)="trigger.emit($event)"
    (triggerKeydown)="triggerKeydown.emit($event)"
  />
</div>

@if (
  (this.incomingDucts()?.length ?? 0) > 0 ||
  (this.outgoingDucts()?.length ?? 0) > 0
) {
  <section class="duct-section">
    <div class="divider"></div>

    @if ((this.incomingDucts()?.length ?? 0) > 0) {
      <app-duct-list-popup-content
        [titleKey]="'pointInfo.ductRow.incoming'"
        [nameLabelKey]="'pointInfo.ductRow.name'"
        [fromToLabelKey]="'pointInfo.ductRow.from'"
        [rows]="this.incomingDucts() ?? []"
        [useFromPoint]="true"
        [startExpanded]="false"
      />
    }

    @if ((this.outgoingDucts()?.length ?? 0) > 0) {
      <app-duct-list-popup-content
        [titleKey]="'pointInfo.ductRow.outgoing'"
        [nameLabelKey]="'pointInfo.ductRow.name'"
        [fromToLabelKey]="'pointInfo.ductRow.to'"
        [rows]="this.outgoingDucts() ?? []"
        [useFromPoint]="false"
        [startExpanded]="false"
      />
    }
  </section>
}

<app-popup-button-container
  [primaryButtonText]="primaryButtonText"
  [secondaryButtonText]="secondaryButtonText"
  (primaryButtonClick)="primaryButtonClick.emit()"
  (secondaryButtonClick)="secondaryButtonClick.emit()"
/>
